import { z } from "zod";

export const PostmarkAttachmentSchema = z
  .object({
    Name: z.string(),
    Content: z.string(),
    ContentType: z.string().optional(),
  })
  .passthrough();

const Address = z.object({
  Email: z.string(),
  Name: z.string().optional(),
});

export const PostmarkEmailSchema = z
  .object({
    From: z.string(),
    Subject: z.string().default(""),
    ReplyTo: z.string().optional(),
    MessageID: z.string(),
    TextBody: z.string().optional(),
    HtmlBody: z.string().optional(),
    Attachments: z.array(PostmarkAttachmentSchema).optional(),
    ToFull: z.array(Address).optional(),
    CcFull: z.array(Address).optional(),
    BccFull: z.array(Address).optional(),
    Headers: z
      .array(
        z.object({
          Name: z.string(),
          Value: z.string(),
        }),
      )
      .optional(),
  })
  .passthrough();

export type PostmarkEmail = z.infer<typeof PostmarkEmailSchema>;
